import packageJson from '../../package.json';

export const environment = {
  production: true,
  version: packageJson.version,
  graphQLUrl: 'https://api.buenehuber.ch/graphql',
  bidsPageSize: 1,
  exhibitsPageSize: 45
};
